var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-back",
    transform: "translate(-8.375 -9.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12991",
    "data-name": "Path 12991",
    d: "M16.752,25.5a.9.9,0,0,1-.624-.249L8.651,18.14a.881.881,0,0,1,0-1.281l7.477-7.111a.908.908,0,0,1,1.273.024.881.881,0,0,1-.024,1.257l-6.8,6.471,6.8,6.471a.881.881,0,0,1,.024,1.257A.9.9,0,0,1,16.752,25.5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12992",
    "data-name": "Path 12992",
    d: "M26.312,24.778H11.15a.889.889,0,1,1,0-1.778H26.312a.889.889,0,1,1,0,1.778Z",
    transform: "translate(-0.837 -6.389)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArrowBack);
export default __webpack_public_path__ + "static/media/white-arrow-back.dc4263fb5c50622d1b77d7280cdc6c3d.svg";
export { ForwardRef as ReactComponent };